import { useMemo } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { Message } from 'features/home/types'
import { formatPower, formatEventMessage } from '../utils'
import { Cell } from 'react-table'
import { ConsumersWrapper, EventSpan, LightSpan } from './styles'
import { messages } from '../messages'

import { LoadCellWrapper } from '../LoadStatus/styles'
import { getGlyph } from '../LoadStatus/loadIcon'

export const MessageCell = (cell: Cell<Message>) => {
  const glyph = useMemo(() => getGlyph(cell?.row?.original?.image), [cell])

  return (
    <LoadCellWrapper>
      {glyph} <EventSpan>{formatEventMessage(cell?.value)}</EventSpan>
    </LoadCellWrapper>
  )
}

interface Consumer {
  uuid: string
  loadName: string
  power_Wh: number
  percentageOfTotal: number
}

interface Load {
  uuid: string
  loadName: string
}

export const TimeCell = (cell: Cell<Message>) => {
  const { formatDate, formatTime } = useIntl()
  return (
    <>
      {formatDate(cell?.value * 1000)}
      &nbsp;
      <LightSpan>{formatTime(cell?.value * 1000)}</LightSpan>
    </>
  )
}

export const DetailsCell = (cell: Cell<Message>) => {
  if (!cell?.value) {
    return null
  }

  if (cell?.value.topConsumers) {
    return (
      <ConsumersWrapper>
        {cell?.value.topConsumers.map((consumer: Consumer) => (
          <div key={consumer.uuid}>
            {consumer.loadName} &nbsp;
            <LightSpan>
              {formatPower(consumer.power_Wh, { h: true })} -{' '}
              <strong>{Math.round(consumer.percentageOfTotal)}%</strong>
            </LightSpan>
          </div>
        ))}
      </ConsumersWrapper>
    )
  } else if (cell?.value.totalConsumption) {
    return (
      <ConsumersWrapper>
        <div>
          <LightSpan>
            {formatPower(
              cell?.value.totalConsumption?.thisPeriod?.power_Wh ||
                cell?.value?.totalConsumption,
              {
                h: true,
              }
            )}
          </LightSpan>
        </div>
      </ConsumersWrapper>
    )
  } else if (cell?.value.sceneName) {
    return (
      <>
        <FormattedMessage {...messages.sceneName} /> &nbsp;{' '}
        <LightSpan>{cell?.value.sceneName}</LightSpan>
      </>
    )
  } else if (cell?.value.loadName) {
    return (
      <>
        <FormattedMessage {...messages.loadName} /> &nbsp;{' '}
        <LightSpan>{cell?.value.loadName}</LightSpan>
      </>
    )
  } else if (cell?.value.loads) {
    return (
      <ConsumersWrapper>
        {cell?.value.loads.map((load: Load) => (
          <div key={load.uuid}>
            <FormattedMessage {...messages.loadName} /> &nbsp;{' '}
            <LightSpan>{load.loadName}</LightSpan>
          </div>
        ))}
      </ConsumersWrapper>
    )
  } else if (cell?.value.maxWattage) {
    return (
      <FormattedMessage
        {...messages.circuitExceeded}
        values={{
          loadName: cell.value.name,
          power: formatPower(cell.value.powerWatts),
          maxPower: formatPower(cell.value.maxWattage),
        }}
      />
    )
  }
  return null
}
